// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-chat {
  display: flex;
  flex-direction: row;
  max-width: 100%;
}

.progress-board {
  color: white;
  font-size: 16px;
  font-family: Graphik;
  font-weight: 700;
  margin-top: 150px;
  margin-left: 150px;
}

.right-section-chat {
  /* background-color: rgba(0, 0, 0, 0.1); */
  border-radius: 10px;
  min-width: 420px;
  margin-top: 20px;
  padding: 5px;
  /* margin-bottom: 20px; */
  margin-left: 5px;
  height: 550px;
  /* border-radius: 8px; */
  border-width: 1px;
  border-style: solid;
  border-color: rgba(116, 123, 169, 1);
  background-color: rgba(255, 255, 255, 0.05);
  /* max-height: 450px; */
}

.left-section-chat {
  background-color: rgba(30, 32, 61, 1);
  border: 1px solid rgba(107, 92, 209, 1);
  border-radius: 10px;
  min-width: 680px;
  margin-left: 7px;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-right: 20px;
  /* max-height: 450px; */
  display: flex;
  flex-direction: column;
  height: 550px;

}

.title-chart {
  margin-top: 5px;
  margin-left: 10px;
  font-size: 13px;
  font-family: Graphik;
  font-weight: 400;
}

.chat-input-container-chart {
  display: flex;
}

.text-chart {
  margin-top: 5px;
  color: white;
  background-color: rgba(37, 40, 67, 1);
  font-size: 14px;
  font-weight: 300;
  margin-right: 5px;
  font-family: Graphik;
  padding-left: 7px;
  height: 77px;
  width:350px;
  border-radius: 10px;
  border: 1px solid rgba(116, 123, 169, 1);
  background-color: rgba(37, 40, 67, 1);
  text-align:left;
}

.chat-input-chart {
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
  padding: 2px;
  width: 400px;
  font-family: 'Graphik', sans-serif;
  color: black;
  font-size: 14px;
  height: 90px;
}

/* .send-back-chart {
  background-color: rgb(54, 54, 89);
  border-radius: 20px;
  width: 8%;
  margin-bottom: 10px;
} */

/* .chat-input-chart input::placeholder {


  color: #fff;
  font-size: 10px;

} */

/* ThreeDotsLoader.css */
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
}

.loader-f {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 187px;
  padding-top: 50px;
}

.dot {
  width: 10px;
  height: 10px;
  margin: 0 5px;
  border-radius: 50%;
  display: inline-block;
  animation: bounce 1.4s infinite ease-in-out;
}

.red {
  background-color: #8070d4;
  /* Red color */
  animation-delay: -0.32s;
}

.green {
  background-color: #8070d4;
  /* Green color */
  animation-delay: -0.16s;
}

.blue {
  background-color: #8070d4;
  /* Blue color */
}

.loading-text {
  background-color: #3498db;
  /* Red color */
  animation-delay: -0.48s;
}

@keyframes bounce {

  0%,
  80%,
  100% {
    transform: translateY(0);
  }

  40% {
    transform: translateY(-10px);
  }
}

.img1-chart {
  text-align: right;
}

.top-part-chart {
  height: 40px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  flex-direction: row;
  background-color: rgb(54, 54, 89);
  padding: 5px;
  color: white;
  font-size: 13px;
  font-weight: 500;
}

.middile-part-chart {
  height: 930px;
  color: white;
  font-size: 10px;
}

.user-message-container {
  display: flex;
  justify-content: flex-start;
  /* Align to the left for user messages */
  margin: 5px 0;
}

.bot-message-container {
  display: flex;
  justify-content: flex-end;
  /* Align to the right for bot messages */
  margin: 5px 0;
}

.message-text-chart {
  padding: 10px 10px 10px 10px;
  font-size: 12px;
  color: white;
  border-radius: 5px;
  max-width: 1000px;
  width: fit-content;
  margin-left: 30px;
}

/* Additional styles for user and bot message containers, e.g., background color, border, etc. */

.chat-messages-c {
  height: 500px;
  overflow-y: scroll;
}
.section::-webkit-scrollbar-thumb {
  border: 5px solid transparent;
  border-radius: 100px;
  background-color: #8070d4;
  background-clip: content-box;
}
.chat-message-chart {
  display: flex;
  border-radius: 5px;
  flex-direction: row;
}

.chat-message-chart.user-c {
  text-align: left;
}

.user-c {
  /* align-items: end; */
  min-width: 50px;
  margin-top: 10px;
  margin-bottom: 10px;
  /* margin-right:10px; */
  /* margin-left: 100px; */
  text-align: left;
  position: relative;
  max-width: 500px;
  /* padding: 10px; */
  width: fit-content;
  float: left;
}

.bot-c {
  min-width: 50px;
  margin-top: 10px;
  position: relative;
  max-width: 640px;
  margin-bottom: 10px;
  /* min-height: 60px; */
  /* max-height: 100%; */
  /* height: fit-content; */
  /* display: block; */
  /* overflow: auto; */
  padding: 10px;
  color: white;
  text-align: left;
  /* margin-right: 30px; */
  width: fit-content;
  float: left;
}

.bg-user {
  background-color: rgba(116, 123, 169, 1);
  border-radius: 0px 10px 10px 10px;
  border-style: icon solid;
  min-width: 50px;
  margin-left: 40px;
}

.bg-bot {
  background-color: rgba(45, 50, 90, 1);
  border-radius: 0px 10px 10px 10px;
  min-width: 50px;
  max-width: 1200px;
  /* height: auto; */
}

.icon-chat-user {
  width: 25px;
  position: absolute;
  margin-left: 10px;
  /* margin-right: 10px; */
  /* bottom: -15px; */
  /* left: -5px; */
}

.icon-chat-bot {
  width: 25px;
  position: absolute;
  /* margin-right: 50px; */
  /* bottom: -15px; */
  /* right: -5px; */
}

.key-table-cb {
  color: white;
  /* padding-top: 10px;
  padding-bottom: 5px; */
  font-size: 13px;
  font-family: Graphik;
  font-weight: 400;
  margin-top: 10px;
  margin-left: 6px;
  line-height: 20px;
  margin-bottom: 10px;
}

.topside {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
}

.chat-table {
  width: 20px;
}

.detected-ct {
  background-image: linear-gradient(to right, rgba(72, 48, 239, 1), rgba(128, 69, 237, 1));
  height: 60px;
  width: 375px;
  margin-left: 15px;
  border-radius: 8px;
  display: flex;
}
.heading-dt{
  color: white;
  font-size: 14px;
  height: 30px;
  font-family: Graphik;
  font-weight: 500;
text-align: center;
width: 150px;
margin-left: 20px;
}

.heading-dt1{
  color: white;
  font-size: 14px;
  height: 30px;
  font-family: Graphik;
  font-weight: 500;
text-align: center;
width: 100px;
margin-left: 35px;
margin-top: 5px;
}

.chatbot-img{
  height: 100px;
  width: 200px;
  margin-left: 10px;
  margin-top: 10px;
  border-radius: 5px;
  padding: 7px;
  border: 1px solid #FFFFFF;
}

.chatbot-img-full{
  width: 80%;
  border-radius: 5px;
  padding: 7px;
  border: 1px solid #FFFFFF;
  margin: 30px 60px;
}
.detected-ct-below {
  background-color: rgba(121, 93, 239, 1);
  height: 60px;
  width: 200px;
  color: white;
  font-size: 14px;
  font-family: Graphik;
  font-weight: 500;
  /* margin-top: 14px; */
text-align: center;
border-bottom-left-radius: 8px;
border-top-left-radius: 8px;
padding: 5px;
}
.insights-head{
  color: white;
  font-size: 15px;
  font-family: Graphik;
  font-weight: 420;
text-align: left;
margin-top: 20px;
margin-left: 10px;
}

.insight-button{
  width: 400px;
  display: flex;
  margin-left: 10px;
  margin-top: 10px;
  flex-direction: column;
}
.insight-left-button:hover {
  background-color:rgba(116, 123, 169, 1);
  transition: 0.7s;
}
.insight-left-button-l:hover {
  background-color:rgba(116, 123, 169, 1);
  transition: 0.7s;
}
.insight-left-button{
  height: 30px;
  min-width: 170px;
  max-width: 210px;
  border-radius: 18px;
  border-style: solid;
  border-color: rgba(116, 123, 169, 1);
  border-width: 1px;
  color: white;
  font-size: 12px;
  font-family: Graphik;
  font-weight: 400;
  background-color: 
  rgba(37, 40, 67, 1);
  text-align: center;
  margin-bottom: 10px;
}
.insight-left-button-l{
  height: 30px;
  width: 330px;
  border-radius: 18px;
  border-style: solid;
  border-color: rgba(116, 123, 169, 1);
  border-width: 1px;
  color: white;
  font-size: 12px;
  font-family: Graphik;
  font-weight: 400;
  background-color: 
  rgba(37, 40, 67, 1);
  text-align: center;
  margin-bottom: 10px;
}

.send-icon{
  width:50px;
  height: 90px;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  padding-top: 35px;
}


.mic-chart {
  padding: 2px;
  width: 25px;
  height: 25px;
  border-radius: 3px;
  border: 1px solid rgba(116, 123, 169, 1);
  background-color: rgba(37, 40, 67, 1);
  margin-bottom: 10px;
}

.send-chart {
  padding: 2px;
  width: 25px;
  height: 25px;
  margin-bottom: 10px;
  border-radius: 3px;
  border: 1px solid rgba(116, 123, 169, 1);
  background-color: rgba(37, 40, 67, 1);
}

.bottom-part-chart{
  margin-top: 10px;
  border-top: 1px solid  rgba(14, 190, 147, 1);
  margin-bottom: 10px;
}

.midside{
  margin-top: 20px;
  border-top: 1px solid  rgba(14, 190, 147, 1);
}

.message-footer{
  display: flex;
  /* background-color: rgba(116, 123, 169, 1); */
  border: 1px solid  rgba(116, 123, 169, 1);
  height: 34px;  
  justify-content: space-between;
  padding: 5px 10px 5px 10px;
  margin: -10px;
  border-radius: 0px 0px 10px 10px;
  margin-top: 10px;
}
.msg-icon{
  width:17px;
  float:right;
  margin-right: 10px;
  padding-top: 2px;
}

.msg-icon-copy{
  width:12px;
  float:right;
  margin-right: 10px;
  padding-top: 2px;
}

.msg-icon-share{
  width:15px;
  float:right;
  margin-right: 10px;
  padding-top: 2px;
}

.border-score{
  margin-left: 10px;
  padding-left: 10px;
  border-left: 1px solid  white;
  height: 20px;
}

.topside-table{
  width:187px;
  height: 120px;
}

.cal-data {
  color: white;
  padding: 2px;
  margin-top: 6px;
  margin-left: 10px;
  display: flex;
  flex-direction: row;
}

.cal-one {
  padding-right: 50px;
  /* justify-content: space-between; */
}

.cal-row {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  font-family: Graphik;
  padding-top: 10px;
}

.container-cal-data {
    background-color: #25304C;
    width: 100px;
    height: 30px;
    border-style: solid;
    border-width: 1px;
    border-radius: 5px;
    border-color: #8d97dac5;
    text-align: left;
    padding: 5px;
    color: white
}

.processebutton-calculate {
  border-radius: 8px;
  margin-right: 40px;
  background-color: rgba(107, 92, 209, 1);
  color: white;
  text-align: center;
  text-decoration: none;
  font-size: 15px;
  width: 140px;
  height: 30px;
  /* border-style: solid; */
  border: 0px solid rgba(107, 92, 209, 1);
  float: right;
  margin-top: 30px;
  margin-bottom: 10px;
}

/* genaiaks.azurecr.io/corrosiondetection:398 478*/
/* image: genaiaks.azurecr.io/ui:462 486 498 533 549*/

/* apm : 113 */`, "",{"version":3,"sources":["webpack://./src/Chatbot.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,oCAAoC;EACpC,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,aAAa;;AAEf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,wCAAwC;EACxC,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;;;;;GAKG;;AAEH;;;;;;GAMG;;AAEH,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;AACzB;;AAEA;;EAEE;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,gGAAgG;;AAEhG;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,iCAAiC;EACjC,wBAAwB;EACxB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ;wBACsB;EACtB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wFAAwF;EACxF,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB,kBAAkB;AAClB,YAAY;AACZ,iBAAiB;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB,kBAAkB;AAClB,YAAY;AACZ,iBAAiB;AACjB,eAAe;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,uCAAuC;EACvC,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB,kBAAkB;AAClB,8BAA8B;AAC9B,2BAA2B;AAC3B,YAAY;AACZ;AACA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB,gBAAgB;AAChB,gBAAgB;AAChB,iBAAiB;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB;qBACmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB;qBACmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,yCAAyC;EACzC,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,uCAAuC;EACvC,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD,qDAAqD;;AAErD,cAAc","sourcesContent":[".main-chat {\n  display: flex;\n  flex-direction: row;\n  max-width: 100%;\n}\n\n.progress-board {\n  color: white;\n  font-size: 16px;\n  font-family: Graphik;\n  font-weight: 700;\n  margin-top: 150px;\n  margin-left: 150px;\n}\n\n.right-section-chat {\n  /* background-color: rgba(0, 0, 0, 0.1); */\n  border-radius: 10px;\n  min-width: 420px;\n  margin-top: 20px;\n  padding: 5px;\n  /* margin-bottom: 20px; */\n  margin-left: 5px;\n  height: 550px;\n  /* border-radius: 8px; */\n  border-width: 1px;\n  border-style: solid;\n  border-color: rgba(116, 123, 169, 1);\n  background-color: rgba(255, 255, 255, 0.05);\n  /* max-height: 450px; */\n}\n\n.left-section-chat {\n  background-color: rgba(30, 32, 61, 1);\n  border: 1px solid rgba(107, 92, 209, 1);\n  border-radius: 10px;\n  min-width: 680px;\n  margin-left: 7px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  margin-right: 20px;\n  /* max-height: 450px; */\n  display: flex;\n  flex-direction: column;\n  height: 550px;\n\n}\n\n.title-chart {\n  margin-top: 5px;\n  margin-left: 10px;\n  font-size: 13px;\n  font-family: Graphik;\n  font-weight: 400;\n}\n\n.chat-input-container-chart {\n  display: flex;\n}\n\n.text-chart {\n  margin-top: 5px;\n  color: white;\n  background-color: rgba(37, 40, 67, 1);\n  font-size: 14px;\n  font-weight: 300;\n  margin-right: 5px;\n  font-family: Graphik;\n  padding-left: 7px;\n  height: 77px;\n  width:350px;\n  border-radius: 10px;\n  border: 1px solid rgba(116, 123, 169, 1);\n  background-color: rgba(37, 40, 67, 1);\n  text-align:left;\n}\n\n.chat-input-chart {\n  margin-left: 10px;\n  margin-right: 10px;\n  margin-top: 10px;\n  padding: 2px;\n  width: 400px;\n  font-family: 'Graphik', sans-serif;\n  color: black;\n  font-size: 14px;\n  height: 90px;\n}\n\n/* .send-back-chart {\n  background-color: rgb(54, 54, 89);\n  border-radius: 20px;\n  width: 8%;\n  margin-bottom: 10px;\n} */\n\n/* .chat-input-chart input::placeholder {\n\n\n  color: #fff;\n  font-size: 10px;\n\n} */\n\n/* ThreeDotsLoader.css */\n.loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n}\n\n.loader-f {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n  width: 187px;\n  padding-top: 50px;\n}\n\n.dot {\n  width: 10px;\n  height: 10px;\n  margin: 0 5px;\n  border-radius: 50%;\n  display: inline-block;\n  animation: bounce 1.4s infinite ease-in-out;\n}\n\n.red {\n  background-color: #8070d4;\n  /* Red color */\n  animation-delay: -0.32s;\n}\n\n.green {\n  background-color: #8070d4;\n  /* Green color */\n  animation-delay: -0.16s;\n}\n\n.blue {\n  background-color: #8070d4;\n  /* Blue color */\n}\n\n.loading-text {\n  background-color: #3498db;\n  /* Red color */\n  animation-delay: -0.48s;\n}\n\n@keyframes bounce {\n\n  0%,\n  80%,\n  100% {\n    transform: translateY(0);\n  }\n\n  40% {\n    transform: translateY(-10px);\n  }\n}\n\n.img1-chart {\n  text-align: right;\n}\n\n.top-part-chart {\n  height: 40px;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  display: flex;\n  flex-direction: row;\n  background-color: rgb(54, 54, 89);\n  padding: 5px;\n  color: white;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.middile-part-chart {\n  height: 930px;\n  color: white;\n  font-size: 10px;\n}\n\n.user-message-container {\n  display: flex;\n  justify-content: flex-start;\n  /* Align to the left for user messages */\n  margin: 5px 0;\n}\n\n.bot-message-container {\n  display: flex;\n  justify-content: flex-end;\n  /* Align to the right for bot messages */\n  margin: 5px 0;\n}\n\n.message-text-chart {\n  padding: 10px 10px 10px 10px;\n  font-size: 12px;\n  color: white;\n  border-radius: 5px;\n  max-width: 1000px;\n  width: fit-content;\n  margin-left: 30px;\n}\n\n/* Additional styles for user and bot message containers, e.g., background color, border, etc. */\n\n.chat-messages-c {\n  height: 500px;\n  overflow-y: scroll;\n}\n.section::-webkit-scrollbar-thumb {\n  border: 5px solid transparent;\n  border-radius: 100px;\n  background-color: #8070d4;\n  background-clip: content-box;\n}\n.chat-message-chart {\n  display: flex;\n  border-radius: 5px;\n  flex-direction: row;\n}\n\n.chat-message-chart.user-c {\n  text-align: left;\n}\n\n.user-c {\n  /* align-items: end; */\n  min-width: 50px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  /* margin-right:10px; */\n  /* margin-left: 100px; */\n  text-align: left;\n  position: relative;\n  max-width: 500px;\n  /* padding: 10px; */\n  width: fit-content;\n  float: left;\n}\n\n.bot-c {\n  min-width: 50px;\n  margin-top: 10px;\n  position: relative;\n  max-width: 640px;\n  margin-bottom: 10px;\n  /* min-height: 60px; */\n  /* max-height: 100%; */\n  /* height: fit-content; */\n  /* display: block; */\n  /* overflow: auto; */\n  padding: 10px;\n  color: white;\n  text-align: left;\n  /* margin-right: 30px; */\n  width: fit-content;\n  float: left;\n}\n\n.bg-user {\n  background-color: rgba(116, 123, 169, 1);\n  border-radius: 0px 10px 10px 10px;\n  border-style: icon solid;\n  min-width: 50px;\n  margin-left: 40px;\n}\n\n.bg-bot {\n  background-color: rgba(45, 50, 90, 1);\n  border-radius: 0px 10px 10px 10px;\n  min-width: 50px;\n  max-width: 1200px;\n  /* height: auto; */\n}\n\n.icon-chat-user {\n  width: 25px;\n  position: absolute;\n  margin-left: 10px;\n  /* margin-right: 10px; */\n  /* bottom: -15px; */\n  /* left: -5px; */\n}\n\n.icon-chat-bot {\n  width: 25px;\n  position: absolute;\n  /* margin-right: 50px; */\n  /* bottom: -15px; */\n  /* right: -5px; */\n}\n\n.key-table-cb {\n  color: white;\n  /* padding-top: 10px;\n  padding-bottom: 5px; */\n  font-size: 13px;\n  font-family: Graphik;\n  font-weight: 400;\n  margin-top: 10px;\n  margin-left: 6px;\n  line-height: 20px;\n  margin-bottom: 10px;\n}\n\n.topside {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 10px;\n}\n\n.chat-table {\n  width: 20px;\n}\n\n.detected-ct {\n  background-image: linear-gradient(to right, rgba(72, 48, 239, 1), rgba(128, 69, 237, 1));\n  height: 60px;\n  width: 375px;\n  margin-left: 15px;\n  border-radius: 8px;\n  display: flex;\n}\n.heading-dt{\n  color: white;\n  font-size: 14px;\n  height: 30px;\n  font-family: Graphik;\n  font-weight: 500;\ntext-align: center;\nwidth: 150px;\nmargin-left: 20px;\n}\n\n.heading-dt1{\n  color: white;\n  font-size: 14px;\n  height: 30px;\n  font-family: Graphik;\n  font-weight: 500;\ntext-align: center;\nwidth: 100px;\nmargin-left: 35px;\nmargin-top: 5px;\n}\n\n.chatbot-img{\n  height: 100px;\n  width: 200px;\n  margin-left: 10px;\n  margin-top: 10px;\n  border-radius: 5px;\n  padding: 7px;\n  border: 1px solid #FFFFFF;\n}\n\n.chatbot-img-full{\n  width: 80%;\n  border-radius: 5px;\n  padding: 7px;\n  border: 1px solid #FFFFFF;\n  margin: 30px 60px;\n}\n.detected-ct-below {\n  background-color: rgba(121, 93, 239, 1);\n  height: 60px;\n  width: 200px;\n  color: white;\n  font-size: 14px;\n  font-family: Graphik;\n  font-weight: 500;\n  /* margin-top: 14px; */\ntext-align: center;\nborder-bottom-left-radius: 8px;\nborder-top-left-radius: 8px;\npadding: 5px;\n}\n.insights-head{\n  color: white;\n  font-size: 15px;\n  font-family: Graphik;\n  font-weight: 420;\ntext-align: left;\nmargin-top: 20px;\nmargin-left: 10px;\n}\n\n.insight-button{\n  width: 400px;\n  display: flex;\n  margin-left: 10px;\n  margin-top: 10px;\n  flex-direction: column;\n}\n.insight-left-button:hover {\n  background-color:rgba(116, 123, 169, 1);\n  transition: 0.7s;\n}\n.insight-left-button-l:hover {\n  background-color:rgba(116, 123, 169, 1);\n  transition: 0.7s;\n}\n.insight-left-button{\n  height: 30px;\n  min-width: 170px;\n  max-width: 210px;\n  border-radius: 18px;\n  border-style: solid;\n  border-color: rgba(116, 123, 169, 1);\n  border-width: 1px;\n  color: white;\n  font-size: 12px;\n  font-family: Graphik;\n  font-weight: 400;\n  background-color: \n  rgba(37, 40, 67, 1);\n  text-align: center;\n  margin-bottom: 10px;\n}\n.insight-left-button-l{\n  height: 30px;\n  width: 330px;\n  border-radius: 18px;\n  border-style: solid;\n  border-color: rgba(116, 123, 169, 1);\n  border-width: 1px;\n  color: white;\n  font-size: 12px;\n  font-family: Graphik;\n  font-weight: 400;\n  background-color: \n  rgba(37, 40, 67, 1);\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.send-icon{\n  width:50px;\n  height: 90px;\n  display: flex;\n  flex-direction: column;\n  margin-top: 10px;\n  padding-top: 35px;\n}\n\n\n.mic-chart {\n  padding: 2px;\n  width: 25px;\n  height: 25px;\n  border-radius: 3px;\n  border: 1px solid rgba(116, 123, 169, 1);\n  background-color: rgba(37, 40, 67, 1);\n  margin-bottom: 10px;\n}\n\n.send-chart {\n  padding: 2px;\n  width: 25px;\n  height: 25px;\n  margin-bottom: 10px;\n  border-radius: 3px;\n  border: 1px solid rgba(116, 123, 169, 1);\n  background-color: rgba(37, 40, 67, 1);\n}\n\n.bottom-part-chart{\n  margin-top: 10px;\n  border-top: 1px solid  rgba(14, 190, 147, 1);\n  margin-bottom: 10px;\n}\n\n.midside{\n  margin-top: 20px;\n  border-top: 1px solid  rgba(14, 190, 147, 1);\n}\n\n.message-footer{\n  display: flex;\n  /* background-color: rgba(116, 123, 169, 1); */\n  border: 1px solid  rgba(116, 123, 169, 1);\n  height: 34px;  \n  justify-content: space-between;\n  padding: 5px 10px 5px 10px;\n  margin: -10px;\n  border-radius: 0px 0px 10px 10px;\n  margin-top: 10px;\n}\n.msg-icon{\n  width:17px;\n  float:right;\n  margin-right: 10px;\n  padding-top: 2px;\n}\n\n.msg-icon-copy{\n  width:12px;\n  float:right;\n  margin-right: 10px;\n  padding-top: 2px;\n}\n\n.msg-icon-share{\n  width:15px;\n  float:right;\n  margin-right: 10px;\n  padding-top: 2px;\n}\n\n.border-score{\n  margin-left: 10px;\n  padding-left: 10px;\n  border-left: 1px solid  white;\n  height: 20px;\n}\n\n.topside-table{\n  width:187px;\n  height: 120px;\n}\n\n.cal-data {\n  color: white;\n  padding: 2px;\n  margin-top: 6px;\n  margin-left: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.cal-one {\n  padding-right: 50px;\n  /* justify-content: space-between; */\n}\n\n.cal-row {\n  display: flex;\n  flex-direction: row;\n  font-size: 12px;\n  font-family: Graphik;\n  padding-top: 10px;\n}\n\n.container-cal-data {\n    background-color: #25304C;\n    width: 100px;\n    height: 30px;\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 5px;\n    border-color: #8d97dac5;\n    text-align: left;\n    padding: 5px;\n    color: white\n}\n\n.processebutton-calculate {\n  border-radius: 8px;\n  margin-right: 40px;\n  background-color: rgba(107, 92, 209, 1);\n  color: white;\n  text-align: center;\n  text-decoration: none;\n  font-size: 15px;\n  width: 140px;\n  height: 30px;\n  /* border-style: solid; */\n  border: 0px solid rgba(107, 92, 209, 1);\n  float: right;\n  margin-top: 30px;\n  margin-bottom: 10px;\n}\n\n/* genaiaks.azurecr.io/corrosiondetection:398 478*/\n/* image: genaiaks.azurecr.io/ui:462 486 498 533 549*/\n\n/* apm : 113 */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
